import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Col, Container, Modal, Row } from "reactstrap";

const Section = () => {
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);
  return (
    <React.Fragment>
      <section className="section bg-home align-items-center d-flex" id="home">
        <div className="color-overlay"></div>
        <Container>
          <Row className="justify-content-center">
            <Col lg={10}>
              <div className="text-center text-white">
                <h1 className="home-title fw-normal">
                  A digital web {" "}
                  <span className="demo heading-title">
                    <span className="demo-inner">
                      <span data-animate="panel">
                        <span className="fw-bold text is-animated">
                          design studio creating
                        </span>
                      </span>
                    </span>
                  </span>
                  modern & engaging online
                </h1>
                <div className="pt-4 mt-5">
                  <Link
                    to="#"
                    onClick={toggle}
                    className="btn btn-primary btn-round  home-button"
                  >
                    Get Started Now
                    <span className="play-shadow ms-2">
                      <span className="home-btn">
                        <i className="mdi mdi-play text-center"></i>
                      </span>
                    </span>
                  </Link>
                  <span className="ps-4">Call Us: (252) 501-631-7032</span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <Modal
          isOpen={modal}
          toggle={toggle}
          className="bd-example-modal-lg"
          centered
          size="lg"
        >
          <button type="button" onClick={() => setModal(false)} className="close text-white"><span aria-hidden="true">×</span></button>
          <video id="VisaChipCardVideo" className="video-box" controls>
            <source
              src="https://www.w3schools.com/html/mov_bbb.mp4"
              type="video/mp4"
            />
          </video>
        </Modal>
      </section>
    </React.Fragment>
  );
};

export default Section;
